import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { styled } from '@mui/material/styles';
import { GenericFallbacksWrapper } from '../../../../components/Fallback/GenericFallbacksWrapper';
import { INewsDataModel } from '../../../../data-models/news.data-model';
import { newsByCompanyIdState } from '../../../../services/state/NewsStateJ';
import { TertiaryForbiddenMessage } from '../../../CompanyProfiles2/Summary/constants/forbidden-messages.constants';
import { selectedCompanyIdProfileAtom } from '../../state/UIStateJ';
import { NoDataMessage2 } from '../../components/Messages/HelpMessage';
import { NewsRow } from './NewsRow';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NewsSection: FC = () => {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const news = useAtomValue(newsByCompanyIdState(companyId))
    ?.filter((n) => Boolean(n.date))
    .toSorted((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  if (!news || !news.length) {
    return (
      <GenericFallbacksWrapper forbiddenFallback={TertiaryForbiddenMessage}>
        <NoDataMessage2 message='No news available' />
      </GenericFallbacksWrapper>
    );
  }

  return (
    <GenericFallbacksWrapper forbiddenFallback={TertiaryForbiddenMessage}>
      <Wrapper id='News'>
        {news.map((n) => (
          <NewsRow key={n.id} news={n as INewsDataModel} />
        ))}
      </Wrapper>
    </GenericFallbacksWrapper>
  );
};
